import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../../environments/environment';
import { SmartApp } from '../models/smart-app.model';
import { ApiResponse } from '../models/api-response';

@Injectable()
export class SmartAppService {
  private readonly endpointUrl: string = environment.apiUrl + '/smart-app';

  constructor(private http: HttpClient) {}

  getSmartApps(): Observable<SmartApp[]> {
    return this.http
      .get<ApiResponse<SmartApp>>(this.endpointUrl)
      .pipe(map(this.extractData), catchError(this.handleError));
  }

  private extractData(data: any): SmartApp[] {
    return data.results || [];
  }

  private handleError(error: any) {
    const errMsg = error.message
      ? error.message
      : error.status
      ? `${error.status} - ${error.statusText}`
      : 'Server error';
    console.error(errMsg);
    return throwError(() => errMsg);
  }
}
